import { createFileRoute, redirect } from "@tanstack/react-router";
import { HokageMigratedTemplate } from "~/features/hokageMigration/HokageMigratedTemplate";
import { isHokageMigratedRoutingEnabled } from "~/lib/hokageMigration";

export const Route = createFileRoute("/hokage-migrated")({
  beforeLoad: () => {
    if (!isHokageMigratedRoutingEnabled()) throw redirect({ to: "/login" });
  },
  component: HokageMigratedTemplate,
});
